
function Challenge() {
  return (
    <section className="py-16 md:py-24 lg:py-32">
      <div className="container">
        <div className="info mb-16 md:mb-20 lg:mb-32 pb-8 md:pb-12 border-b border-gray-300">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            <div className="item mb-8 md:mb-12">
              <span className="block opacity-80 mb-2 text-sm md:text-base">Category :</span>
              <h6 className="text-lg md:text-xl font-semibold">Development</h6>
            </div>
            <div className="item mb-8 md:mb-12">
              <span className="block opacity-80 mb-2 text-sm md:text-base">Client :</span>
              <h6 className="text-lg md:text-xl font-semibold">Envato</h6>
            </div>
            <div className="item mb-8 md:mb-12">
              <span className="block opacity-80 mb-2 text-sm md:text-base">Start Date :</span>
              <h6 className="text-lg md:text-xl font-semibold">7 August 2021</h6>
            </div>
            <div className="item">
              <span className="block opacity-80 mb-2 text-sm md:text-base">Designer :</span>
              <h6 className="text-lg md:text-xl font-semibold">UiCamp</h6>
            </div>
          </div>
        </div>
        <div className="flex justify-center">
          <div className="w-full lg:w-11/12">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12">
              <div className="lg:col-span-5">
                <h4 className="mb-8 md:mb-12 text-2xl md:text-3xl lg:text-4xl font-semibold">The Challenge</h4>
              </div>
              <div className="lg:col-span-7">
                <div className="text">
                  <h5 className="mb-6 md:mb-8 font-normal leading-relaxed md:leading-loose text-lg md:text-xl lg:text-2xl">
                    The goal is there are many variations of passages of Lorem
                    Ipsum available, but the majority have suffered alteration
                    in some form, by injected humour, or randomised words which
                    don&apos;t look even slightly believable.
                  </h5>
                  <p className="text-base md:text-lg lg:text-xl leading-relaxed">
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form, by injected humour, or randomised words which
                    don&apos;t look even slightly believable. If you are going
                    to use a passage of Lorem Ipsum, you need to be sure there
                    isn&apos;t anything embarrassing hidden in the middle of
                    text.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Challenge;
